export default "__VITE_ASSET__6b60fdf0__"